import React from 'react';
import './App.css';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import WhyItMatters from './components/WhyItMatters';
import EarlyPilots from './components/EarlyPilots';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Hero />
      <EarlyPilots />
      <HowItWorks />
      <WhyItMatters />
      <Footer />
    </div>
  );
}

export default App;
